import { isPwaApp } from './config/appMode';
import {
  applyPwaDocumentClass,
  isStandalonePwa,
  shouldShowPwaMobileUi,
} from './utils/pwaUtils';

const DEFAULT_TITLE = 'Project Management Dashboard';
const DEFAULT_THEME = '#464646';
const DEFAULT_DESCRIPTION =
  'Track and manage projects efficiently with our Project Management Dashboard. Monitor progress, deadlines, tasks, budgets, and team collaboration in real-time.';

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function applyDesktopSiteDocument() {
  document.documentElement.classList.remove('nettles-pwa-app');
  document.documentElement.style.backgroundColor = '';
  if (document.body) {
    document.body.style.backgroundColor = '';
  }
  document.title = DEFAULT_TITLE;
  setMeta('description', DEFAULT_DESCRIPTION);
  setMeta('theme-color', DEFAULT_THEME);
  setMeta('apple-mobile-web-app-status-bar-style', 'default');
  setLink('manifest', `${process.env.PUBLIC_URL}/manifest.json`);
  setLink('apple-touch-icon', `${process.env.PUBLIC_URL}/logo192.png`);
  setLink('icon', `${process.env.PUBLIC_URL}/favicon.ico`);
}

function applyMobilePwaDocument() {
  document.documentElement.classList.add('nettles-pwa-app');
  document.title = 'Project';
  setMeta(
    'description',
    'Project list, dashboard, and field production tracking.'
  );
  setMeta('mobile-web-app-capable', 'yes');
  setMeta('apple-mobile-web-app-capable', 'yes');
  // Same as red app-bar era: installed PWA uses translucent status bar so the
  // page/header background (now white, was #ad2226) shows through continuously.
  // Browser tab still uses opaque default status bar.
  setMeta(
    'apple-mobile-web-app-status-bar-style',
    isStandalonePwa() ? 'black-translucent' : 'default'
  );
  setMeta('apple-mobile-web-app-title', 'Project');
  setMeta('theme-color', '#ffffff');
  // Continuous white behind status bar + app bar (was #ad2226 when red).
  document.documentElement.style.backgroundColor = '#ffffff';
  if (document.body) {
    document.body.style.backgroundColor = '#ffffff';
  }
  setLink('manifest', `${process.env.PUBLIC_URL}/manifest.pwa.json`);
  setLink('apple-touch-icon', `${process.env.PUBLIC_URL}/apple-touch-icon.png`);
  setLink('icon', `${process.env.PUBLIC_URL}/favicon-32.png`);
}

/** Keep desktop browser unchanged; apply PWA document chrome only on mobile / installed. */
export function syncPwaDocumentUi() {
  if (!isPwaApp) {
    return;
  }

  applyPwaDocumentClass();

  if (shouldShowPwaMobileUi()) {
    applyMobilePwaDocument();
  } else {
    applyDesktopSiteDocument();
  }
}
